import _get from 'lodash/get';
import initialState from './initialState';
import actionType from './actionType';

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
            };
        case actionType.GET_USER_INFO_SUCCESS: {
            return {
                ...state,
                userInfo: {
                    ...state.userInfo,
                    ...action.payload,
                },
            };
        }
        case actionType.GET_USER_DETAILS_SUCCESS: {
            return {
                ...state,
                userDetails: action.payload,
            };
        }
        case actionType.LOGIN_FAILURE: {
            return {
                ...state,
                error: {
                    isOpen: true,
                    message: action.payload || 'Invalid Login Credentials',
                },
            };
        }
        case actionType.GET_ALL_EN_USERS_SUCCESS: {
            return {
                ...state,
                userData: action.payload,
            };
        }
        case actionType.GET_ALL_EN_ROLES_SUCCESS: {
            return {
                ...state,
                roleData: action.payload,
            };
        }
        case actionType.GET_ALL_EN_APPLICATIONS_SUCCESS: {
            return {
                ...state,
                applicationConfigurations: action.payload,
            };
        }
        case actionType.GET_ALL_EN_DASHBOARD_SUCCESS: {
            return {
                ...state,
                dashboardConfigurations: action.payload,
            };
        }
        case actionType.GET_ALL_EN_ROUTES_SUCCESS: {
            return {
                ...state,
                routesConfigurations: action.payload,
            };
        }
        case actionType.SET_ARRAY_SUCCESS: {
            return {
                ...state,
                onChangeCaptureRoutesConfiguration: action.payload,
            };
        }
        case actionType.UPDATE_ONCHANGE_CAPTURE_ROUTE_PERMISSIONS: {
            return {
                ...state,
                onChangeCaptureRoutePermissions: action.payload,
            };
        }
        case actionType.GET_APPLICATION_SCREEN_PERMISSION_SUCCESS: {
            return {
                ...state,
                screenPermissions: _get(action.payload, 'screen_permissions', []),
            };
        }
        case actionType.GET_ALL_ROLES_DASHBOARD: {
            return {
                ...state,
                allRolesDashboard: action.payload,
            };
        }
        default:
            return state;
    }
};

export default usersReducer;
